module.exports = __webpack_public_path__ + "img/plus.b9e87763.svg";